import { Component, Input, OnInit } from '@angular/core';
import { BadgeDefinitionDTO } from '../../../../interfaces/gamification/badge-definition.dto';

@Component({
  selector: 'badge-progress-small-circle',
  templateUrl: 'badge-progress-small-circle.component.html',
  styleUrls: ['badge-progress-small-circle.component.scss'],
})
export class BadgeProgressSmallCircleComponent implements OnInit {
  constructor() {}

  _progress: number;
  @Input('progress') // percentage between 0 and 100 (will be constrained)
  public set progress(value: number) {
    this._progress = Math.min(Math.max(value, 0), 100);
    this.setDegrees();
  }
  public get progress(): number {
    return this._progress;
  }

  degrees: number = 0;
  rotate: number = 0;

  @Input() badge: BadgeDefinitionDTO;

  ngOnInit() {}

  setDegrees() {
    this.degrees = 180.0 * (this._progress / 100.0);
    this.rotate = 90.0 + (180 - this.degrees);
  }
}
